import React, { useEffect, useState } from "react"
import Text from "../text/index"
import { colors } from "../../lib/colors"
import { RESULT_PROPS } from "./interface"
import { CheckWinner } from "functions/getWinner"
import { WinText } from "components/text/style"
import useSound from "use-sound"
import winSFX from "lib/audio/sounds/win.mp3"
import loseSFX from "lib/audio/sounds/lose.mp3"
import { Currencies } from "@orbitalgaming/games-frontend-library"

export const ResultComponent = ({
  betInfo,
  align,
  showResult,
  dealOut,
  betReply,
  marginTop = "68px",
  marginBottom,
  audio,
  currency,
  justify,
  precision,
}: RESULT_PROPS): JSX.Element => {
  const { text, win } = CheckWinner(betInfo, precision)
  const [resultSound, setResultSound] = useState<boolean>(true)

  const [playWinSFX] = useSound(winSFX, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
    onend: () => {
      setResultSound(false)
    },
  })
  const [playLoseSFX] = useSound(loseSFX, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
    onend: () => {
      setResultSound(false)
    },
  })

  useEffect(() => {
    showResult && setResultSound(true)
  }, [showResult])

  useEffect(() => {
    if (showResult && audio?.sound && resultSound) {
      if (win) {
        playWinSFX()
      } else {
        playLoseSFX()
      }
    }
  }, [win, showResult, resultSound])
  return (
    <WinText betReply={betReply} showResult={showResult} dealOut={dealOut}>
      <Text
        size='16px'
        color={colors.secondary}
        fontWeight='700'
        align={align || "center"}
        justify={justify}
        marginTop={marginTop}
        marginBottom={marginBottom}
      >
        {win && <span className='win'>WIN</span>}
        {win && Currencies[currency]}
        {text}
      </Text>
    </WinText>
  )
}
